/* eslint-disable import/prefer-default-export */
export const USER_TOKENS_LOCAL_STORE_KEY = 'user'
